<template>
  <div>
    <v-flex xs12
      class="mt-3"
    >
      <lender-card :lender="lender"
        v-if="lender.id !== 'greensky'"
      />
      <v-img v-else
        :src="creditApproval"
        max-height=250
        contain
      />
    </v-flex>
    <v-flex xs12
      class="mt-3"
    >
      <v-list class="px-4">
        <label-value-tile
          :label="'Application ID'"
          :value="applicationId"
        />
        <v-divider/>
        <label-value-tile
          :label="'Applicant'"
          :value="applicantName"
        />
        <v-divider/>
        <label-value-tile
          :label="'Date'"
          :value="currentDate"
        />
        <v-divider/>
        <label-value-tile
          :label="'Interest Rate'"
          :value="annualPercentageRate"
        />
        <v-divider/>
        <label-value-tile
          :label="'Post-Promo Term'"
          :value="termLength"
        />
        <v-divider/>
        <label-value-tile
          :label="'Post-Promo Monthly Payment'"
          :value="monthlyPayment"
          :labelTooltip="monthlyPaymentLeftTooltip"
          :valueTooltip="monthlyPaymentRightTooltip"
        />
      </v-list>
    </v-flex>
  </div>
</template>

<script>
  import LabelValueTile from 'Components/LabelValueTile.vue'
  import LenderCard from 'Components/LenderCard.vue'
  import moment from 'moment'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'SingleOffer',
    components: {
      LabelValueTile,
      LenderCard
    },
    data() {
      return {
        creditApproval: require('@/assets/credit-approval.png'),
      }
    },
    computed: {
      ...mapGetters([
        'selectedOffer'
      ]),
      ...mapState({
        applicationId: state => state.loanApplication.applicationId,
        customerData: state => state.loanApplication.customerData,
        lender: state => state.loanApplication.lender,
        loanAmount: state => state.loanApplication.loanAmount
      }),
      annualPercentageRate () {
        return this.selectedOffer.apr + '%'
      },
      applicantName () {
        return this.customerData.firstName + ' ' + this.customerData.lastName
      },
      approvedAmount () {
        return this.$options.filters.currency(this.selectedOffer.amount)
      },
      currentDate () {
        return moment().format('MM-DD-YYYY')
      },
      monthlyPayment () {
        return '$' + this.selectedOffer.monthly_payment
      },
      monthlyPaymentLeftTooltip () {
        return `This is just an estimate based on ${this.approvedAmount}. After your first purchase, you will receive monthly statements to track your actual payments and transactions.`
      },
      monthlyPaymentRightTooltip () {
        return `Estimated payments based on ${this.approvedAmount} and may not represent actual payments after the purchase.`
      },
      termLength () {
        return this.selectedOffer.term_length + ' Months'
      }
    }
  }
</script>
